import { useEffect, useState } from 'react';

import { addSocketEventListener, removeSocketEventListener } from '@shared/lib/realtime';

const SOCKET_EVENT = 'promo_roll_synth:generation_failed';

type PromoRollSynthGenerationFailedPayload = {
  jobId: string;
  failureMessage: string;
};

export const usePromoRollSynthJobFailureMessage = (jobId: string): string | undefined => {
  const [failureMessage, setFailureMessage] = useState<string>();

  useEffect(() => {
    const handleGenerationFailed = (payload: PromoRollSynthGenerationFailedPayload) => {
      if (payload.jobId === jobId) {
        setFailureMessage(payload.failureMessage);
      }
    };

    addSocketEventListener(SOCKET_EVENT, handleGenerationFailed);

    return () => removeSocketEventListener(SOCKET_EVENT, handleGenerationFailed);
  }, [jobId]);

  return failureMessage;
};
